/**
 * A saved view's name as the page shows it (#13370 round 36i). No dependencies, so the pure
 * modules that name views (the tab row, the record page's tab arrangement) can use it.
 */

/** What a Documents & Interactions view Appearance makes is called (round 36i). */
export const AGGREGATE_DEFAULT_NAME = "Documents & Interactions";
/** The name it was made with before round 36i, which no one chose. */
const OLD_AGGREGATE_DEFAULT_NAME = "Documents & interactions";

/**
 * A view's name as it is shown (Gerry: "instead of Default Documents & interactions, with
 * interactions lowercase, make it Documents & Interactions"): a name a user gave is theirs and is
 * shown as stored, but the old default name, which no one chose, is shown in the new casing.
 * Nothing is written: a stored view keeps its name until it is renamed.
 */
export const viewDisplayName = (name: string): string =>
  name === OLD_AGGREGATE_DEFAULT_NAME ? AGGREGATE_DEFAULT_NAME : name;

/** A view as the page reads it: its name as it is shown. */
export const shownView = <V extends { name: string }>(view: V): V =>
  viewDisplayName(view.name) === view.name
    ? view
    : { ...view, name: viewDisplayName(view.name) };
